(function () {
  if (window.WristbuddyKlaviyoCustomEvents) return;
  window.WristbuddyKlaviyoCustomEvents = true;

  var ADDED_TO_CART_COLLECTION_EVENT = "Added to Cart Collection";
  var ADDED_TO_CART_EVENT = "Added to Cart";
  var CUSTOM_ADDED_TO_CART_EVENT = "[CUSTOM] Added to Cart";
  var COLLECTION_VIEWED_EVENT = "[CUSTOM] Collection Page Viewed";
  var DEDUPE_MS = 1500;
  var CART_OBSERVER_DEBOUNCE_MS = 250;
  var emittedCartItemKeys = new Map();
  var trackedCartItemKeys = new Map();
  var cartObserverTimer = null;
  var lastCartCollectionTrackKey = "";

  function pruneRecent(map) {
    var now = Date.now();
    map.forEach(function (timestamp, key) {
      if (now - timestamp > DEDUPE_MS) map.delete(key);
    });
  }

  function getBody() {
    return document.body || document.querySelector("body");
  }

  function isCollectionPage() {
    var body = getBody();
    if (!body) return false;

    return body.classList.contains("template-collection") || body.dataset.template === "collection";
  }

  function isDebugEnabled() {
    if (window.WristbuddyKlaviyoDebug) return true;

    try {
      return Boolean(window.localStorage && window.localStorage.getItem("wristbuddy:klaviyo-debug") === "true");
    } catch {
      return false;
    }
  }

  function debugLog() {
    if (!isDebugEnabled()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[klaviyo-custom-events]");
    window.console.log.apply(window.console, args);
  }

  function trackEvent(eventName, eventData) {
    eventData = eventData || {};
    debugLog("trackEvent", eventName, eventData);

    if (window.klaviyo && typeof window.klaviyo.push === "function") {
      debugLog("using window.klaviyo.push");
      window.klaviyo.push(["track", eventName, eventData]);
      return;
    }

    if (window._klOnsite && typeof window._klOnsite.push === "function") {
      debugLog("using window._klOnsite.push");
      window._klOnsite.push(["track", eventName, eventData]);
      return;
    }

    window._learnq = window._learnq || [];
    if (typeof window._learnq.push === "function") {
      debugLog("using _learnq.push");
      window._learnq.push(["track", eventName, eventData]);
    }
  }

  function trackLearnqEvent(eventName, eventData) {
    eventData = eventData || {};
    debugLog("trackLearnqEvent", eventName, eventData);

    window._learnq = window._learnq || [];
    if (typeof window._learnq.push === "function") {
      window._learnq.push(["track", eventName, eventData]);
    }
  }

  function parseCartAddPayload(init) {
    if (!init || !init.body) return {};

    if (typeof init.body === "string") {
      try {
        return JSON.parse(init.body);
      } catch {
        return {};
      }
    }

    if (window.FormData && init.body instanceof FormData) {
      return {
        id: init.body.get("id"),
        quantity: init.body.get("quantity"),
      };
    }

    if (window.URLSearchParams && init.body instanceof URLSearchParams) {
      return {
        id: init.body.get("id"),
        quantity: init.body.get("quantity"),
      };
    }

    return {};
  }

  function normalizeCartItem(item, fallback) {
    item = item || {};
    fallback = fallback || {};

    var variantId = item.variant_id || item.variantId || (item.variant && item.variant.id) || item.id || fallback.id;
    var productId = item.product_id || item.productId || (item.product && item.product.id);
    var title = item.product_title || item.productTitle || (item.product && item.product.title) || item.title;
    var quantity = Number(item.quantity || fallback.quantity || 1);

    return {
      id: productId || variantId,
      product_id: productId || null,
      title: title || "",
      product_title: title || "",
      variant_id: variantId || null,
      price: item.final_price || item.price || item.line_price || null,
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
      url: item.url || "",
      image: item.image || (item.featured_image && item.featured_image.url) || "",
    };
  }

  function normalizeCartSnapshotItem(item) {
    item = item || {};

    return {
      id: item.product_id || item.id || null,
      title: item.product_title || item.title || "",
      variant: item.variant_id || item.id || null,
      price: item.final_price || item.price || null,
      quantity: item.quantity || 1,
      image: item.image || (item.featured_image && item.featured_image.url) || "",
    };
  }

  function buildCartSnapshotPayload(cart) {
    cart = cart || {};

    return {
      event_cart_url: window.location.origin + (window.routes && window.routes.cart_page_url || "/cart"),
      items: Array.isArray(cart.items) ? cart.items.map(normalizeCartSnapshotItem) : [],
    };
  }

  function buildAddedToCartPayload(cart) {
    cart = cart || {};

    return {
      total_price: cart.total_price || 0,
      $value: typeof cart.total_price === "number" ? cart.total_price / 100 : 0,
      total_discount: cart.total_discount || 0,
      original_total_price: cart.original_total_price || cart.total_price || 0,
      items: Array.isArray(cart.items) ? cart.items.map(normalizeCartSnapshotItem) : [],
    };
  }

  function getCartUrl() {
    var root = window.routes && window.routes.localeRootUrl || "";
    return root + "/cart.js";
  }

  async function fetchCartSnapshot() {
    var response = await fetch(getCartUrl(), {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) throw new Error("Cart fetch failed");

    return response.json();
  }

  function getCartItemKey(product) {
    if (!product) return "";
    return [
      product.product_id || product.id || "",
      product.variant_id || "",
      product.quantity || 1,
      product.price || "",
    ].join(":");
  }

  function dispatchCartItemAdded(product, source) {
    if (!product) return;

    pruneRecent(emittedCartItemKeys);

    var key = getCartItemKey(product);
    if (key && emittedCartItemKeys.has(key)) return;
    if (key) emittedCartItemKeys.set(key, Date.now());

    debugLog("dispatch cart:item-added", product, source);

    document.dispatchEvent(
      new CustomEvent("cart:item-added", {
        bubbles: true,
        detail: {
          product: product,
          source: source || "theme",
        },
      })
    );
  }

  function trackCartItemAdded(event) {
    var product = event && event.detail && event.detail.product;
    if (!product) return;

    product = normalizeCartItem(product);

    pruneRecent(trackedCartItemKeys);

    var key = getCartItemKey(product);
    if (key && trackedCartItemKeys.has(key)) return;
    if (key) trackedCartItemKeys.set(key, Date.now());

    debugLog("track cart:item-added", product);

    trackEvent(CUSTOM_ADDED_TO_CART_EVENT, {
      product_id: product.product_id || product.id,
      product_title: product.title || product.product_title,
      variant_id: product.variant_id,
      price: product.price,
      quantity: product.quantity || 1,
      collection_context: isCollectionPage(),
    });
  }

  function normalizeCartAddResponse(data, payload) {
    if (data && Array.isArray(data.items)) {
      return data.items.map(function (item) {
        return normalizeCartItem(item, payload);
      });
    }

    if (data && (data.id || data.variant_id || data.product_id)) {
      return [normalizeCartItem(data, payload)];
    }

    if (payload && Array.isArray(payload.items)) {
      return payload.items.map(function (item) {
        return normalizeCartItem({}, item);
      });
    }

    if (payload && payload.id) {
      return [normalizeCartItem({}, payload)];
    }

    return [];
  }

  function isCartAddRequest(input) {
    var url = "";

    if (typeof input === "string") {
      url = input;
    } else if (input && input.url) {
      url = input.url;
    }

    if (!url) return false;

    try {
      var parsed = new URL(url, window.location.origin);
      return /\/cart\/add(?:\.js)?$/.test(parsed.pathname);
    } catch {
      return url.indexOf("/cart/add") !== -1;
    }
  }

  function isCartMutationUrl(url) {
    if (!url) return false;

    try {
      var parsed = new URL(url, window.location.origin);
      return /\/cart\/(?:add|change)(?:\.js)?$/.test(parsed.pathname);
    } catch {
      return url.indexOf("/cart/add") !== -1 || url.indexOf("/cart/change") !== -1;
    }
  }

  function trackAddedToCartCollection(cart, source) {
    var payload = buildCartSnapshotPayload(cart);
    var key = JSON.stringify(payload.items.map(function (item) {
      return [item.id, item.variant, item.quantity].join(":");
    }));

    if (key === lastCartCollectionTrackKey) return;
    lastCartCollectionTrackKey = key;

    debugLog("track Added to Cart Collection", payload, source);
    trackLearnqEvent(ADDED_TO_CART_COLLECTION_EVENT, payload);
  }

  function scheduleCartCollectionTracking(source) {
    if (cartObserverTimer) window.clearTimeout(cartObserverTimer);

    cartObserverTimer = window.setTimeout(async function () {
      cartObserverTimer = null;

      try {
        var cart = await fetchCartSnapshot();
        trackAddedToCartCollection(cart, source);
      } catch {}
    }, CART_OBSERVER_DEBOUNCE_MS);
  }

  async function handleCartAddResponse(data, init) {
    var payload = parseCartAddPayload(init);
    var products = normalizeCartAddResponse(data, payload);
    var primaryProduct = products[0];

    dispatchCartItemAdded(primaryProduct, "cart-add-fetch");

    try {
      var cart = await fetchCartSnapshot();
      trackLearnqEvent(ADDED_TO_CART_EVENT, buildAddedToCartPayload(cart));
    } catch {}
  }

  async function processCartAddResponse(response, init) {
    var data = await response.clone().json();
    await handleCartAddResponse(data, init);
  }

  function installFetchListener() {
    if (!window.fetch || window.fetch.__wristbuddyKlaviyoWrapped) return;

    var originalFetch = window.fetch;
    var wrappedFetch = async function (input, init) {
      var response = await originalFetch.apply(this, arguments);

      if (response && response.ok && isCartAddRequest(input)) {
        processCartAddResponse(response, init).catch(function () {});
      }

      if (response && response.ok && isCartMutationUrl(input && input.url ? input.url : input)) {
        scheduleCartCollectionTracking("performance-fetch");
      }

      return response;
    };

    wrappedFetch.__wristbuddyKlaviyoWrapped = true;
    window.fetch = wrappedFetch;
  }

  function installCartResourceObserver() {
    if (!("PerformanceObserver" in window)) return;

    try {
      var observer = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (entry && isCartMutationUrl(entry.name)) {
            scheduleCartCollectionTracking("performance-observer");
          }
        });
      });

      observer.observe({ entryTypes: ["resource"] });
    } catch {
      debugLog("PerformanceObserver is unavailable for resource entries");
    }
  }

  function installProductAddedFallback() {
    document.addEventListener("product:added", function (event) {
      var detail = (event && event.detail) || {};
      var lineItem = detail.lineItem;

      if (!lineItem) return;

      normalizeCartAddResponse(lineItem, {
        id: detail.variant,
        quantity: detail.quantity,
      }).slice(0, 1).forEach(function (product) {
        dispatchCartItemAdded(product, detail.source || "product-added");
      });
    });
  }

  function trackCollectionViewed() {
    if (!isCollectionPage()) return;

    trackEvent(COLLECTION_VIEWED_EVENT, {
      collection_url: window.location.pathname,
      collection_name: document.title,
    });
  }

  function init() {
    document.addEventListener("cart:item-added", trackCartItemAdded);
    installFetchListener();
    installCartResourceObserver();
    installProductAddedFallback();
    trackCollectionViewed();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
